import { FilterBar, SelectV2, SortDropdownValue } from "@/modules/common/components";
import { EntityFilterBar, UseFiltersResult } from "@/modules/common/filters";
import {
  ADMIN_USER_ROLE_OPTIONS,
  ADMIN_USER_STATUS_OPTIONS,
  AdminUserRole,
  AdminUserSortField,
  AdminUserStatus,
} from "@/modules/common/types/Users.enum";

import { ADMIN_USER_FILTER_FIELDS } from "../../constants/AdminUserFilterFields";
import { ListAdminUsersDto } from "@/service/dto/admin-users";

const ADMIN_USER_SORT_OPTIONS = [
  { field: AdminUserSortField.NAME, label: "Nome" },
  { field: AdminUserSortField.CREATED_AT, label: "Data de criação" },
  { field: AdminUserSortField.LAST_LOGIN_AT, label: "Último acesso" },
];

interface UsersFilterBarProps {
  filters: UseFiltersResult<ListAdminUsersDto>;
  sort: SortDropdownValue<AdminUserSortField> | null;
  onSortChange: (sort: SortDropdownValue<AdminUserSortField> | null) => void;
}

const UsersFilterBar = ({ filters, sort, onSortChange }: UsersFilterBarProps) => {
  return (
    <EntityFilterBar
      filters={filters}
      sort={sort}
      onSortChange={onSortChange}
      sortOptions={ADMIN_USER_SORT_OPTIONS}
      filterFields={ADMIN_USER_FILTER_FIELDS}
      modalTitle="Filtrar Usuários"
    >
      <FilterBar.Item>
        <SelectV2
          mode="single"
          placeholder="Perfil"
          options={ADMIN_USER_ROLE_OPTIONS}
          value={filters.values.role !== undefined ? String(filters.values.role) : undefined}
          onChange={(next) => filters.setValue("role", next !== undefined ? (Number(next) as AdminUserRole) : undefined)}
        />
      </FilterBar.Item>

      <FilterBar.Item>
        <SelectV2
          mode="single"
          placeholder="Status"
          options={ADMIN_USER_STATUS_OPTIONS}
          value={filters.values.status !== undefined ? String(filters.values.status) : undefined}
          onChange={(next) => filters.setValue("status", next !== undefined ? (Number(next) as AdminUserStatus) : undefined)}
        />
      </FilterBar.Item>
    </EntityFilterBar>
  );
};

export default UsersFilterBar;
